import { fill } from "cypress/types/lodash";
import Image from "next/image";
import Link from "next/link";
import { useContext } from "react";
import { Banner } from "../../../../models/home-rows";
import {
  createBannerUrl
} from "../../../../services/api-services";
import AppContext from "../../../../services/app-context-services";
import { trackEvent } from "../../../../services/ga-services";
import styles from "./banner.module.scss";

interface BannerProps {
  banner: Banner;
}

function Banner({ banner }: BannerProps) {
  const appCtx = useContext(AppContext);
  const { dg_id, isLoggedIn } = appCtx;

  return (
    <>{banner?.bg_img && (<div
      onClick={() => trackEvent("Home Item", "Banner")}
      className={`${styles.banner_wrapper}`}
      style={{ backgroundColor: banner?.bg_color }}
    >
      {banner?.url ? (
        <Link prefetch={false}
          href={createBannerUrl(banner?.url, dg_id, isLoggedIn)}
          target="_blank"
        >
          <a className={styles.full_banner}>
            <img src={banner.bg_img} alt="ردیف بنر" className="img-fluid" />
          </a>
        </Link>
      ) : <div className={styles.full_banner}>
          <img src={banner.bg_img} alt="ردیف بنر" className="img-fluid" />
        </div>}
    </div>)}</>
  );
}

export default Banner;
